import React from 'react';

interface DeleteConfirmationDialogProps {
    isVisible: boolean;
    onDelete: () => void;
    onCancel: () => void;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
    isVisible,
    onDelete,
    onCancel
}) => {
    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white dark:bg-neutral-800 p-6 rounded-lg shadow-xl max-w-md">
                <h3 className="text-lg font-semibold mb-4 text-neutral-800 dark:text-neutral-200">
                    Delete Custom Mode
                </h3>
                <p className="text-neutral-600 dark:text-neutral-400 mb-6">
                    Are you sure you want to delete this custom mode? This action cannot be undone.
                </p>
                <div className="flex space-x-3 justify-end">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 text-neutral-600 dark:text-neutral-400 hover:text-neutral-800 dark:hover:text-neutral-200"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onDelete}
                        className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded"
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationDialog;